<template>             
      <div ref="liste" class="liste mission-search pa-2">
        <v-list>   
      <auto-virtual-scroll-list v-resize="onResize" :totalHeight="height"
        :defaultHeight="36"
        :extra-items="5"
        style="width: 100%;">
          <div class="line-item" v-for="mission in filteredMission" :key="mission.misId"> 
            <div class="heading ml-2" style="display:flex;">                 
              <span class="line-item-state" style="display:inline-block"><mission-state :mission="mission"  /></span>
              <v-btn class="missionbtn" :class="{testMission:mission.isTestMission}" flat :to="'/cache/mission/'+mission.misId"  >
                <span class="line-item-libelle">{{mission.misLibelle}}</span>
                <span class="line-item-connect">{{mission.misActifOn?$t('Pilot.MissionSearch.LastConnect'):$t('Pilot.MissionInfos.EndDate')}}:</span> {{ mission.yoArray[mission.yoArray.length -1 ] && mission.yoArray[mission.yoArray.length -1 ].yoGpsDatTime | formatDate }}
              </v-btn>                                          
            </div>            
        </div>        
      </auto-virtual-scroll-list>
    </v-list>
    </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import MissionState from '@/components/mission/MissionState'
  export default {
    name: 'CacheSearch', 
    components:{MissionState},           
    data() {
      return {     
        height: 100
      }
   },
   computed: {
       ...mapGetters([
         'filteredMission'
      ])      
    },    
    mounted(){
      this.onResize()
    },
    methods: {
      onResize() {
        this.height = this.$refs.liste.clientHeight - 20       
      }            
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
  .line-item-state
  {
    display: inline-block;
    min-width: 40px;
  }
  .line-item-libelle{
     display: inline-block;
      min-width: 300px;
  }
  .line-item-connect{
    text-transform: initial; 
     display: inline-block;
     min-width: 110px;   
     text-align: right;
     margin-right: 10px;
  }
  .mission-search{
    background-color:#ddd;    
  }
  .liste {
    flex: 1 1 auto;
    overflow: hidden;
    height: min-content;
  }
</style>